import React from 'react';
import { Card, Text, DonutChart, Legend } from '@tremor/react';
import { ParkingStats, ParkingType } from '../../types';

interface ParkingDistributionChartProps {
  stats: ParkingStats;
}

const ParkingDistributionChart: React.FC<ParkingDistributionChartProps> = ({ stats }) => {
  const donutChartData = Object.entries(stats.parkingTypeStats).map(([type, data]) => ({
    name: `${type} Parking`,
    value: data.occupied,
  }));

  return (
    <Card>
      <Text className="text-contentColor font-medium text-lg">Parking Distribution</Text>
      <Text className="text-contentColor">Current distribution of vehicles by parking type</Text>
      <DonutChart
        className="mt-6"
        data={donutChartData}
        category="value"
        index="name"
        valueFormatter={(value) => `${value} vehicles`}
        colors={['emerald', 'amber', 'blue']}
        variant="pie"
      />
      <Legend
        className="mt-3"
        categories={[
          `${ParkingType.RENTED} Parking`,
          `${ParkingType.PUBLIC} Parking`,
          `${ParkingType.DEDICATED} Parking`,
        ]}
        colors={['emerald', 'amber', 'blue']}
      />
    </Card>
  );
};

export default ParkingDistributionChart;